import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../contexts/authContext';
import { portfolioClient } from '../../../lib/connect/clients';
export const PORTFOLIO_ECONOMICS_KEY = [
    'portfolio-economics'
];
/**
 * Canonical portfolio economics (GP-16): the portfolio row plus one row per
 * Landscape, already deduplicated and aggregated server-side. Never sum the
 * rows client-side. landscapeIds empty = the whole portfolio.
 */ export function usePortfolioEconomics(landscapeIds = []) {
    const { user } = useAuth();
    const enabled = !!user?.tenant_id && !!user?.id;
    const query = useQuery({
        queryKey: [
            ...PORTFOLIO_ECONOMICS_KEY,
            landscapeIds,
            user?.tenant_id,
            user?.id
        ],
        enabled,
        queryFn: ()=>portfolioClient.getPortfolioEconomics({
                landscapeIds
            }),
        retry: false
    });
    return {
        ...query,
        data: enabled && !query.isError ? query.data : undefined
    };
}
